export { RegisterStudentAnonymouslyMutation } from './mutations';
export {
    GetOLCertificateURLForAnonStudentQuery,
    GetOLCertificatesURLForDictation2024,
} from './queries';
